import { render } from "./MenuItem.vue?vue&type=template&id=2879ae66&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=2879ae66&scoped=true&lang=css"

import exportComponent from "/home/runner/work/joshpotterton.com/joshpotterton.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2879ae66"]])

export default __exports__